<div class="d-flex flex-row status-box">
  <div class="asc icon-status" *ngIf="status === 'asc'">
    <svg width="5px" height="3px" viewBox="0 0 8 5" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <defs>
        <polygon id="path-asc" points="7.21 8 6.5 8.71 10.04 12.24 13.58 8.71 12.87 8 10.04 10.83"></polygon>
      </defs>
      <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="Keyicons/Chevron-up" transform="translate(-6.000000, -8.000000)">
          <g id="Chevron-down">
            <mask id="mask-2" fill="white">
              <use xlink:href="#path-asc"></use>
            </mask>
            <use id="Mask" [ngStyle]="{'fill': color}" fill="#717D8D" fill-rule="nonzero" transform="translate(10.040000, 10.120000) rotate(-180.000000) translate(-10.040000, -10.120000) " xlink:href="#path-asc"></use>
          </g>
        </g>
      </g>
    </svg>
  </div>

  <div class="desc icon-status" *ngIf="status === 'desc'">
    <svg width="5px" height="3px" viewBox="0 0 8 5" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <defs>
        <polygon id="path-desc" points="7.21 8 6.5 8.71 10.04 12.24 13.58 8.71 12.87 8 10.04 10.83"></polygon>
      </defs>
      <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="Keyicons/Chevron-down" transform="translate(-6.000000, -8.000000)">
          <g id="Chevron-down">
            <mask id="mask-2" fill="white">
              <use xlink:href="#path-desc"></use>
            </mask>
            <use id="Mask" [ngStyle]="{'fill': color}" fill="#717D8D" fill-rule="nonzero" xlink:href="#path-desc"></use>
          </g>
        </g>
      </g>
    </svg>
  </div>
  <div class="box-value">{{value | percentNumberSuffix}}</div>
</div>



// WEBPACK FOOTER //
// ./src/app/core/achoo-index-status/achoo-index-status.component.html